import angular from 'angular';

/*******************************************************************************
* @ngdoc    object
* @module   csm.books.data
* @name     csm.books.data.type:BooksData#DGJournalItem
* @constructor
* @param {object=} src Source object to populate properties.
* @description
* Datagrid journal item class for journal entries/adjustments. This will manage 
* a child JournalItem object.
*
* TODO: This uses the Backstore pattern with accessors to `mJournalItem`, which 
* TODO: is more of a challenge to inherit. Needs to be refactored into the 
* TODO: Direct-Access pattern such as in `MakeDeposit`.
*******************************************************************************/
/* @ngInject */ export function RunDGJournalItem(BooksData, Tools) {
  BooksData.DGJournalItem = function (src) {
    var ji = Object.assign(
      Object.create(BooksData.DGJournalItem.prototype),
      {}
    );

    ji.mJournalItem = src || {};
    ji.mAccount =
      src && src.accountID
        ? {
            accountName: ji.source.accountName,
            accountNumber: ji.source.accountNumber,
            accountID: ji.source.accountID,
            type: ji.source.accountType
          }
        : null;
    ji.mClass =
      src && src.classID
        ? { id: ji.source.classID || 0, name: ji.source.className }
        : null;

    ji.calculate();
    return ji;
  };

  /*****************************************************************************
   * Prototype
   *****************************************************************************/
  BooksData.DGJournalItem.prototype = {
    /*----------------------*/
    /* Internal Properties. */
    /*----------------------*/
    mJournalItem: null,
    mAccount: null,
    mClass: null,

    restricted: false,
    code: [],

    get account() {
      return this.mAccount;
    },
    get class() {
      return this.mClass;
    },
    get source() {
      return this.mJournalItem;
    },
    get accountName() {
      return this.account ? this.source.name || this.account.accountName : '';
    },
    get accountNumber() {
      return this.account
        ? this.source.number || this.account.accountNumber
        : '';
    },
    get accountType() {
      return this.account ? this.mAccount.accountType : '';
    },
    get amount() {
      return this.source.amount;
    },
    get className() {
      return this.class ? this.class.name : '';
    },
    get credit() {
      return this.source.credit;
    },
    get debit() {
      return this.source.debit;
    },
    get isCleared() {
      return this.source.isCleared;
    },
    get isCredit() {
      return this.source.credit > 0;
    },

    set account(value) {
      this.mAccount = value;
      this.source.accountID = angular.isObject(this.account)
        ? this.account.accountID
        : 0;
    },
    set amount(value) {
      this.source.amount = isNaN(value)
        ? value
        : Tools.roundToPrecision(value, 2);
    },
    set class(value) {
      this.mClass = value;
      this.source.classID =
        (angular.isObject(this.class) ? this.class.id : 0) || 0;
    },
    set credit(value) {
      this.source.credit = value;
    },
    set debit(value) {
      this.source.debit = value;
    },
    set accountName(value) {
      /* Reject nonmatching text values from the typeahead. */
    },
    set accountNumber(value) {
      /* Reject nonmatching text values from the typeahead. */
    },
    set accountType(value) {
      /* This is a read-only field. */
    },
    set className(value) {
      /* Reject nonmatching text values from the typeahead. */
    },
    set isCleared(value) {
      /* This is a read only field. */
    },
    set isCredit(value) {
      /* This is a read only field. */
    },

    /***************************************************************************
     * calculate */
    /**
     * Normalizes the Credit and Debit values, and sets the journal item type.
     ***************************************************************************/
    calculate: function () {
      var balance = (this.source.debit || 0) - (this.source.credit || 0);

      this.source.credit = balance > 0 ? 0 : Math.abs(balance);
      this.source.debit = balance < 0 ? 0 : balance;

      this.source.amount = Math.abs(balance);
    },

    /***************************************************************************
     * hideDelete */
    /**
     * Accessor for when to hide the delete button.
     ***************************************************************************/
    hideDelete: function () {
      return (
        (this.source && (this.source.isCleared || this.source.statementID)) ||
        this.restricted
      );
    }
  };
}
